import moment from "moment";

import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { DayOfWeek } from "@/Common/Models/DayOfWeek";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";
import { OpeningHour } from "@/Common/Models/Sites/OpeningHour";

interface IOpeningHoursSubSectionProps {
    openingHours: OpeningHour[];
    localizedOpeningHoursNote: LocalizedTextDto;
}

function OpeningHoursSubSection(props: IOpeningHoursSubSectionProps): JSX.Element {
    const { openingHours, localizedOpeningHoursNote } = props;
    const timeFormat = "HH:mm";
    const siteOpeningHours: OpeningHour[] = EnumHelper
        .getValues(DayOfWeek)
        .map(dayOfWeek => {
            const openingHour = openingHours?.find(item => item.DayOfWeek === dayOfWeek);

            return {
                DayOfWeek: openingHour?.DayOfWeek || dayOfWeek,
                OpeningTime: openingHour?.OpeningTime ? moment(openingHour.OpeningTime, timeFormat).format(timeFormat) : null,
                ClosingTime: openingHour?.ClosingTime ? moment(openingHour.ClosingTime, timeFormat).format(timeFormat) : null
            };
        });
    const newSiteOpeningHours = [...siteOpeningHours?.slice(1), siteOpeningHours[0]];

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{cacheStore.GetString("ClinicInfo_OpeningHoursLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                {newSiteOpeningHours?.map((item: OpeningHour, index: number) => (
                    <div key={`hours_${index}`} className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{AdministrationHelper.getDayOfWeekLabel(item?.DayOfWeek)}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            {item.OpeningTime && item.ClosingTime
                                ? <strong>{item.OpeningTime} - {item.ClosingTime}</strong>
                                : <strong>{cacheStore.GetString("ClinicInfo_SiteClosedLabel")}</strong>
                            }
                        </div>
                    </div>
                ))}
            </div>

            <div className="view-subsection-body">
                {AdministrationHelper.getLocalizedTextSiteViewArray(localizedOpeningHoursNote).map((item, index) => (
                    <div key={`openingHourNote_${index}`} className="row">
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{`${cacheStore.GetString("NotesLabel")} (${item.languageName})`}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <strong>{item.value}</strong>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { IOpeningHoursSubSectionProps };
export default OpeningHoursSubSection;
